<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M2.327 2.638C2 3.28 2 4.12 2 5.8v4.4c0 1.68 0 2.52.327 3.162a3 3 0 001.311 1.311C4.28 15 5.12 15 6.8 15h2.4c1.68 0 2.52 0 3.162-.327a3 3 0 001.311-1.311C14 12.72 14 11.88 14 10.2V9.143c0-1.066 0-1.6-.198-2.01a2 2 0 00-.934-.935C12.456 6 11.923 6 10.858 6c-.8 0-1.2 0-1.509-.149a1.5 1.5 0 01-.7-.7C8.5 4.842 8.5 4.443 8.5 3.643V1H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 00-1.311 1.311zm9.437-.756L10 1v3.238c0 .145.117.262.262.262h2.12c.685 0 1.312.387 1.618 1v-.053a4 4 0 00-2.189-3.541l-.047-.024z"
    fill="currentColor"
  />
</svg>
